import { Model } from '@vuex-orm/core'

export default class Step extends Model {
  declare id: number
  declare name: string
  declare componentName: string
  declare active: boolean
  declare completed: boolean
  declare enabled: boolean

  static entity = 'steps'

  static fields() {
    return {
      id: this.attr(null),
      name: this.string(''),
      componentName: this.string(''),
      active: this.boolean(false),
      completed: this.boolean(false),
      enabled: this.boolean(false)
    }
  }

  complete() {
    this.completed = true
    this.$save()
  }

  previous() {
    const step = Step.query().find(+this.id - 1)
    if (step) {
      step.activate()
    }

  }

  next() {
    return Step.query().find(+this.id + 1)
  }

  static activateAll() {
    this.update({
      where: () => true,
      data: { enabled: true }
    })
  }

  static deactivateAll() {
    this.update({
      where: () => true,
      data: { enabled: false }
    })
  }

  static deactivateAllBut(id: number, markAsComplete = false) {
    this.update({
      where: record => record.id !== id,
      data: markAsComplete
        ? { enabled: false, complete: true }
        : { enabled: false }
    })
  }

  uncomplete() {
    const _thisId = this.id

    Step.update({
      where: step => step.id >= _thisId,
      data: (step: Step) => {
        step.active = step.id === _thisId
        step.completed = false
        step.enabled = step.id === _thisId
      }
    })
  }

  completeAndNext(next = false) {
    const step = Step.query()
      .where((record: Step) => record.id === (this.id + 1))
      .first()

    if (!step) { return }

    this.complete()
    step.enable()
    if (next) {
      step.activate()
    }
  }

  enable() {
    this.enabled = true
    this.$save()
  }

  disable() {
    this.enabled = false
    return this.$save()
  }

  activate() {
    if (!this.enabled) { return }

    const steps = Step.query().get()
    steps.forEach((step) => {
      Step.insertOrUpdate({
        data: {
          id: step.id,
          active: false
        }
      })

      // Step.insertOrUpdate({
      //   data: {
      //     id: step.id,
      //     active: false
      //   }
      // })
    })

    this.active = true
    this.$save()
  }

  deactivate() {
    if (!this.enabled) { return }

    this.active = false
    this.$save()
  }
}
